<template>
  <div class="min-h-screen flex flex-col bg-white md:items-center md:justify-center">
    <!-- Top image with rounded bottom corners -->
    <div class="relative w-full md:max-w-md md:rounded-2xl md:shadow-lg md:overflow-hidden md:bg-white">
      <img
        src="@/assets/images/welcome-picture.png"
        alt="Welcome"
        class="w-full object-cover rounded-b-3xl shadow-lg md:rounded-b-2xl md:rounded-t-2xl"
        style="margin-top: -210px;"
      />
      <!-- Overlay card with text -->
      <div class="absolute inset-0 flex flex-col justify-end items-start rounded-b-3xl px-6 pb-10 md:rounded-b-2xl">
        <h1 class="text-white text-3xl font-bold leading-tight mb-2 text-left">
          Benvenuto in<br />
          CastingUp<sup class="text-base align-super">®</sup> Italia
        </h1>
        <p class="text-white text-base text-left">
          Diventa il protagonista di videoclip, spot pubblicitari e trasmissioni televisive girate in tutta Italia.
        </p>
      </div>
    </div>

    <!-- Spacer to account for overlay -->
    <div class="h-8"></div>

    <!-- Signin buttons (same width) -->
    <div class="mx-6 mt-2 md:max-w-md md:mx-auto flex flex-col gap-4">
      <CuButton primary class="w-full" @click="showPhoneSheet = true">
        <i class="bx bx-phone text-2xl"></i>
        Accedi con il numero
      </CuButton>
      <div class="flex items-center my-2">
        <div class="flex-1 h-px bg-gray-200"></div>
        <span class="mx-3 text-gray-400 font-medium">oppure</span>
        <div class="flex-1 h-px bg-gray-200"></div>
      </div>
      <CuButton secondary class="w-full">
        <i class="bx bx-envelope text-2xl"></i>
        Accedi con l'email
      </CuButton>
    </div>

    <!-- Registration link -->
    <div class="mt-4 text-center text-gray-500 text-sm md:max-w-md md:mx-auto">
      Sei nuovo da queste parti?
      <a href="#" class="text-blue-500 font-semibold hover:underline">Registrati</a>
    </div>
    <PhoneNumberSheet
      :show="showPhoneSheet"
      @close="showPhoneSheet = false"
      @confirm="handlePhoneConfirm"
    />
    <PhoneCodeSheet
      :show="showCodeSheet"
      @close="showCodeSheet = false"
      @confirm="handleCodeConfirm"
    />
    
  </div>
</template>

<script>
import CuButton from '../components/cu/CuButton.vue';
import PhoneNumberSheet from '../components/dialog-sheets/PhoneNumberSheet.vue';
import PhoneCodeSheet from '../components/dialog-sheets/PhoneCodeSheet.vue';

export default {
  name: "WelcomeScreen",
  components: {
    CuButton,
    PhoneNumberSheet,
    PhoneCodeSheet,
  },
  data() {
    return {
      showPhoneSheet: false,
      showCodeSheet: false,
    }
  },
  methods: {
    handlePhoneConfirm(phone) {
      // Handle phone number confirmation (e.g., send to API)
      // eslint-disable-next-line no-console
      console.log('Confirmed phone:', phone);
      this.showPhoneSheet = false;
      this.showCodeSheet = true;
      // You can add further logic here
    },
    handleCodeConfirm(code) {
      // Handle code confirmation
      // eslint-disable-next-line no-console
      console.log('Confirmed code:', code);
      this.showCodeSheet = false;
      this.$router.push('/overview');
    },
    
  }
};
</script>
